function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "Inbox_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  className: "Inbox_svg__a",
  transform: "translate(22 124)",
  d: "M0 0h24v24H0z"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  className: "Inbox_svg__b"
}, /*#__PURE__*/React.createElement("path", {
  className: "Inbox_svg__c",
  d: "M.735 22.57A.734.734 0 010 21.836V12.53a.733.733 0 01.042-.244.732.732 0 010-.5L3.474 2.48A.734.734 0 014.163 2h15.674a.735.735 0 01.689.48l3.429 9.306a.73.73 0 010 .5.731.731 0 01.045.244v9.306a.735.735 0 01-.734.734zm.734-1.47H22.53v-7.836h-5.877v2.2a.736.736 0 01-.735.735H8.081a.735.735 0 01-.734-.735v-2.2H1.469zm6.612-9.3a.735.735 0 01.735.734v2.2h6.367v-2.2a.734.734 0 01.734-.734h6.474l-3.067-8.331H4.676L1.608 11.8z"
}));

function SvgInbox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _ref, _ref2);
}

export default SvgInbox;